import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import plCommon from './pl/common.json';
import plAuth from './pl/auth.json';
import plGenerator from './pl/generator.json';
import plProjects from './pl/projects.json';
import plAdmin from './pl/admin.json';
import plApiTesting from './pl/apiTesting.json';
import plErrors from './pl/errors.json';

import enCommon from './en/common.json';
import enAuth from './en/auth.json';
import enGenerator from './en/generator.json';
import enProjects from './en/projects.json';
import enAdmin from './en/admin.json';
import enApiTesting from './en/apiTesting.json';
import enErrors from './en/errors.json';

i18n.use(initReactI18next).init({
  resources: {
    pl: {
      common: plCommon,
      auth: plAuth,
      generator: plGenerator,
      projects: plProjects,
      admin: plAdmin,
      apiTesting: plApiTesting,
      errors: plErrors,
    },
    en: {
      common: enCommon,
      auth: enAuth,
      generator: enGenerator,
      projects: enProjects,
      admin: enAdmin,
      apiTesting: enApiTesting,
      errors: enErrors,
    },
  },
  lng: localStorage.getItem('app_language') || 'pl',
  fallbackLng: 'pl',
  ns: ['common', 'auth', 'generator', 'projects', 'admin', 'apiTesting', 'errors'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
